var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31287 5.34784H23.7923C25.1506 5.34784 26.1997 6.55436 25.9678 7.88045L24.3555 15.3261C24.2561 15.8478 23.8034 16.2174 23.2733 16.2174H7.07356",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83429 26C11.054 26 12.0428 25.0267 12.0428 23.8261C12.0428 22.6255 11.054 21.6522 9.83429 21.6522C8.61454 21.6522 7.62573 22.6255 7.62573 23.8261C7.62573 25.0267 8.61454 26 9.83429 26Z",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9814 26C23.2011 26 24.1899 25.0267 24.1899 23.8261C24.1899 22.6255 23.2011 21.6522 21.9814 21.6522C20.7616 21.6522 19.7728 22.6255 19.7728 23.8261C19.7728 25.0267 20.7616 26 21.9814 26Z",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C3.20856 1 3.20856 2.08696 4.31284 5.34783L7.62567 18.3913C7.735 18.8924 7.99782 19.4783 8.51793 19.4783H24.1899",
    stroke: "#888888",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.f274f0f9aad9cb136e33dbcd9ee3ab9d.svg";
export { ForwardRef as ReactComponent };